module.exports = __webpack_public_path__ + "static/add1-a34e59789177983a818288a168055650.png";